export default {
  // Navigation Tabs & Menus
  tabs: {
    home: 'Inicio',
    services: 'Servicios',
    orders: 'Pedidos',
    wallet: 'Billetera',
    profile: 'Perfil',
  },

  nav: {
    dashboard: 'Panel de control',
    new_order: 'Nuevo pedido',
    services: 'Servicios',
    orders: 'Pedidos',
    deposit: 'Recargar',
    virtual_numbers: 'Números virtuales',
    referrals: 'Programa de referidos',
    settings: 'Ajustes',
    support: 'Soporte',
    guide: 'Guía',
    logout: 'Cerrar sesión',
    login: 'Iniciar sesión',
    signup: 'Empezar gratis',
    features: 'Características',
    platforms: 'Plataformas',
    how_it_works: 'Cómo funciona',
    pricing: 'Precios',
    faq: 'FAQ',
    language: 'Idioma',
  },

  // Common UI
  common: {
    loading: 'Cargando...',
    save: 'Guardar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    back: 'Volver',
    submit: 'Enviar',
    copied: 'Copiado al portapapeles',
    search: 'Buscar...',
    all: 'Todos',
    completed: 'Completado',
    pending: 'Pendiente',
    in_progress: 'En curso',
    failed: 'Fallido',
    cancelled: 'Cancelado',
    partial: 'Parcial',
    see_all: 'Ver todo',
    details: 'Detalles',
    status: 'Estado',
    close: 'Cerrar',
    try_again: 'Reintentar',
    error: 'Error',
    success: 'Éxito',
    something_went_wrong: 'Algo salió mal. Por favor intenta de nuevo.',
    rate_per_1k: 'Tarifa por 1.000',
    min_max: 'Mín / Máx',
    action: 'Acción',
    actions: 'Acciones',
    category: 'Categoría',
    service: 'Servicio',
    quantity: 'Cantidad',
    link: 'Enlace / URL',
    cost: 'Coste',
    total_cost: 'Coste total',
    date: 'Fecha',
    order: 'Pedido',
    refresh: 'Actualizar',
    delivery_time: 'Tiempo de entrega',
    available_balance: 'Saldo disponible',
    add_funds: 'Añadir fondos',
    place_order: 'Crear pedido',
  },

  // Auth Screens
  auth: {
    welcome_title: 'Haz Crecer tu Presencia en Redes',
    welcome_sub: 'La plataforma SMM más rápida y confiable para creadores y empresas.',
    login: 'Iniciar Sesión',
    sign_up: 'Registrarse',
    sign_in: 'Acceder',
    email_or_username: 'Correo electrónico o usuario',
    password: 'Contraseña',
    remember_me: 'Recordarme',
    forgot_password: '¿Olvidaste tu contraseña?',
    or_continue_with: 'O continúa con',
    google: 'Google',
    no_account: '¿No tienes una cuenta?',
    have_account: '¿Ya tienes una cuenta?',
    create_account: 'Crear Cuenta',
    full_name: 'Nombre Completo',
    username: 'Nombre de usuario',
    email: 'Correo Electrónico',
    phone: 'Número de Teléfono',
    confirm_password: 'Confirmar Contraseña',
    agree_terms: 'Acepto los Términos de Servicio y Política de Privacidad',
    reset_password: 'Restablecer Contraseña',
    send_code: 'Enviar Código de Restablecimiento',
  },

  // Dashboard Screen
  dashboard: {
    greeting: 'Hola',
    grow_subtitle: 'Impulsa tus cuentas sociales hoy con entrega ultra rápida',
    current_balance: 'Saldo Actual',
    your_balance: 'Tu Saldo',
    add_funds: '+ Añadir Fondos',
    quick_actions: 'Acciones Rápidas',
    services_catalog: 'Catálogo de Servicios',
    order_now: 'Ordenar Ahora',
    track_orders: 'Seguir Pedidos',
    wallet_topup: 'Recargar Saldo',
    popular_services: 'Servicios Populares',
    recent_orders: 'Pedidos Recientes',
    recent_subtitle: 'Rastrea tus pedidos recientes y el estado de entrega',
    no_orders_yet: 'Aún no has realizado pedidos',
    no_orders_desc: 'Elige un servicio de nuestro catálogo para impulsar tus perfiles hoy.',
    place_first_order: 'Hacer Primer Pedido',
    social_media_services: 'Servicios de Redes Sociales',
    social_media_subtitle: 'Aumenta seguidores, likes y visitas',
    virtual_numbers: 'Números Virtuales',
    virtual_numbers_subtitle: 'Obtén números temporales para verificación',
    popular_social_media_services: 'Servicios Sociales Destacados',
    popular_virtual_numbers: 'Números Virtuales Populares',
    fast_and_reliable: 'Entrega Rápida y Automatizada',
    fast_and_reliable_sub: 'Todos los pedidos comienzan a procesarse automáticamente en segundos.',
    total_orders: 'Pedidos Totales',
    all_time_completed: 'Total completados',
    total_spent: 'Total Gastado',
    lifetime_volume: 'Volumen histórico',
    vn_used: 'Números Virtuales Usados',
    sms_verifications: 'Verificaciones SMS',
    see_all_services: 'Ver todos los servicios',
    browse_countries: 'Ver todos los países',
    view_all_orders: 'Ver Todos los Pedidos →',
  },

  // Services Screen
  services: {
    title: 'Servicios',
    subtitle: 'Elige entre más de 500 paquetes de crecimiento en redes sociales.',
    promo_title: 'Haz Crecer tus Redes Sociales más Rápido',
    promo_subtitle: 'Consigue seguidores, likes, vistas e interacciones a precios de mayorista con entrega automática.',
    quick_order: 'Pedido Rápido',
    show_all_platforms: 'Mostrar Todas las Plataformas',
    search_placeholder: 'Buscar por servicio, categoría o ID (ej. 1024, TikTok, Instagram)...',
    all_categories: 'Todas las Categorías',
    popular_packages: 'Paquetes Populares',
    buy_now: 'Comprar',
    order: 'Ordenar',
    min: 'Mín',
    max: 'Máx',
    per_1k: 'por 1.000',
    instant_delivery: 'Entrega Inmediata',
    high_retention: 'Alta Retención',
    safe_secure: '100% Seguro y Privado',
    no_services_found: 'No se encontraron servicios que coincidan con tu búsqueda.',
    social_media_tab: 'Redes Sociales',
    virtual_numbers_tab: 'Números Virtuales',
    favorites: 'Favoritos',
    all_platforms: 'Todas las Plataformas',
    grid_view: 'Tarjetas',
    table_view: 'Tabla',
  },

  // Virtual Numbers
  virtual_numbers: {
    title: 'Números Virtuales',
    subtitle: 'Obtén números temporales o de alquiler para recibir códigos SMS.',
    promo_title: 'Números Virtuales Privados para Cualquier Servicio',
    promo_desc: 'Consigue números temporales para verificación en apps y páginas web con entrega SMS instantánea.',
    buy_number: 'Comprar Número',
    orders: 'Pedidos',
    rents: 'Alquilar Número',
    my_numbers: 'Mis Números',
    instant_delivery: 'Entrega inmediata',
    wide_selection: 'Amplia selección de países',
    affordable_prices: 'Precios económicos',
    popular_countries: 'Países Populares',
    popular_services: 'Servicios Populares',
    select_country: 'Seleccionar País',
    select_service: 'Seleccionar Servicio',
    choose_number: 'Elegir Número',
    order_summary: 'Resumen del Pedido',
    step_payment: 'Pago',
    continue_payment: 'Continuar al Pago',
    number_activated: 'Número Activado',
    number_ready: 'Tu número virtual está listo para usarse.',
    time_remaining: 'Tiempo Restante',
    received_codes: 'Códigos Recibidos',
    no_codes_yet: 'Sin códigos aún',
    codes_auto_appear: 'Los códigos SMS recibidos aparecerán aquí automáticamente.',
    instructions_text: 'Abre la aplicación e introduce este número para recibir tu código. Los nuevos SMS se mostrarán en vivo.',
    extend: 'Extender',
    rent_again: 'Alquilar de nuevo',
    cancel: 'Cancelar',
    all_codes: 'Todos los Códigos',
    unread: 'No leídos',
    available: 'Disponible',
    refresh: 'Actualizar',
    phone_number: 'Número de Teléfono',
    view_all: 'Ver Todo >',
    select_provider: 'Seleccionar Proveedor',
    live_rates: 'Tarifas en Vivo',
    choose_provider_sub: 'Elige tu proveedor preferido de números virtuales:',
    instant_sms_desc: 'Verificación SMS instantánea',
    global_pool_desc: 'Cobertura global y amplia variedad',
    country: 'País',
    service: 'Servicio',
    provider: 'Proveedor',
    price: 'Precio',
    auto_assigned: 'Asignado automáticamente al comprar',
    pay_activate_btn: 'Pagar y Activar Número',
    number_details: 'Detalles del Número',
    number_details_sub: 'Tu número ha sido activado. Úsalo para recibir códigos SMS.',
    waiting_for_code: 'Esperando código SMS...',
    instructions: 'Instrucciones',
    instructions_prefix: 'Abre',
    instructions_suffix: 'e introduce este número para recibir el código.',
    view_all_received_codes: 'Ver todos los códigos recibidos →',
    search_service_placeholder: 'Buscar servicio (WhatsApp, Telegram...)',
    search_country_placeholder: 'Buscar país...',
    no_services_found: 'No se encontraron servicios',
    no_countries_found: 'No se encontraron países',
    no_numbers_yet: 'Sin números todavía',
    no_numbers_sub: 'Cuando adquieras un número virtual, aparecerá aquí.',
    buy_a_number: 'Comprar un Número',
    my_rents: 'Mis Alquileres',
    my_rents_sub: 'Gestiona tus números alquilados, extiéndelos y consulta su estado.',
    search_rent_placeholder: 'Buscar número, servicio o país...',
    active: 'Activo',
    expiring: 'Por expirar',
    expired: 'Expirado',
    all: 'Todos',
    back_to_services: '‹ Volver a Servicios',
    back_to_countries: '‹ Volver a Países',
    select_country_continue: 'Selecciona un país para continuar tu compra',
    success_rate: 'Tasa de Éxito',
    confirm_purchase_title: 'Confirmar Compra de Número',
    confirm_purchase_sub: 'Verifica los detalles antes de activar el número virtual.',
    total_deducted: 'Total a deducir',
    your_new_balance: 'Tu saldo tras la compra',
    insufficient_balance: 'Saldo insuficiente para adquirir este número.',
    deposit_to_continue: 'Por favor recarga saldo en tu billetera para continuar.',
  },

  // New Order Screen
  new_order: {
    title: 'Crear Pedido',
    subtitle: 'Ingresa tu enlace y la cantidad deseada para impulsar tu perfil.',
    service_selected: 'Servicio Seleccionado',
    category_label: 'Categoría',
    select_category: 'Seleccionar Categoría',
    service_label: 'Servicio',
    select_service: 'Seleccionar Servicio',
    link_label: 'Enlace / URL de destino',
    link_placeholder: 'ej. https://instagram.com/usuario o enlace de post',
    link_helper: 'Asegúrate de que la cuenta o publicación sea pública',
    quantity_label: 'Cantidad',
    min_max: 'Mín: {min} — Máx: {max}',
    total_price: 'Precio Total',
    place_order_btn: 'Realizar Pedido Ahora',
    order_success_title: '¡Pedido Realizado con Éxito!',
    order_success_sub: 'Tu pedido está siendo procesado y comenzará a entregarse enseguida.',
    order_id: 'ID del Pedido',
    track_orders_btn: 'Ver en Mis Pedidos',
    back_to_services_btn: 'Volver a Servicios',
    comments_label: 'Comentarios Personalizados',
    comments_placeholder: 'Ingresa un comentario por línea...',
    comments_badge: '{count} comentario(s)',
    rate_per_1k: 'Tarifa / 1K',
    delivery_time: 'Tiempo de Entrega',
    service_description: 'Descripción del Servicio',
    quick_presets: 'Cantidades Rápidas',
    insufficient_balance: 'Saldo Insuficiente',
    insufficient_sub: 'Necesitas más fondos en tu billetera para realizar este pedido.',
    deposit_now: 'Recargar Saldo Ahora',
    order_summary: 'Resumen del Pedido',
  },

  // Orders Screen
  orders: {
    title: 'Mis Pedidos',
    subtitle: 'Rastrea el progreso y estado en tiempo real de tus pedidos.',
    search_placeholder: 'Buscar por ID de Pedido, servicio o URL...',
    filter_all: 'Todos',
    filter_pending: 'Pendientes',
    filter_progress: 'En Curso',
    filter_completed: 'Completados',
    filter_partial: 'Parciales',
    filter_cancelled: 'Cancelados',
    no_orders_found: 'No se encontraron pedidos con este filtro.',
    progress: 'Progreso de Entrega',
    view_cards: 'Tarjetas',
    view_table: 'Tabla',
    order_num: 'Pedido',
    service_col: 'Servicio',
    quantity_col: 'Cantidad',
    cost_col: 'Coste',
    status_col: 'Estado',
    date_col: 'Fecha',
    link_col: 'Enlace',
    copy_link: 'Copiar Enlace',
    open_link: 'Abrir Enlace',
  },

  // Wallet / Deposit Screen
  wallet: {
    title: 'Billetera',
    subtitle: 'Recarga saldo en tu cuenta para comprar servicios con facilidad.',
    current_balance: 'Saldo Disponible',
    add_funds: 'Añadir Fondos',
    transaction_history: 'Historial de Transacciones',
    select_amount: 'Seleccionar Monto',
    custom_amount: 'Monto Personalizado',
    enter_amount_placeholder: 'Ingresa el monto (ej. 5000)',
    select_payment_method: '1. Seleccionar Método de Pago',
    phone_number: 'Número de Teléfono',
    proceed_to_payment: 'Proceder al Pago',
    secure_payments: 'Tus pagos son totalmente seguros y encriptados.',
    instant_addition: 'Los fondos se acreditan al instante tras la confirmación.',
    recent_transactions: 'Transacciones Recientes',
    bonus_title: '¡Bono de Primer Depósito Activado!',
    bonus_desc: '¡Obtén un bono extra acreditado directamente al realizar tu primer depósito!',
    quick_amounts: 'Montos Rápidos',
    one_tap_fill: 'En 1 Toque',
    amount_in: 'Monto en {currency}',
    depositing: 'Monto a depositar',
    credited_to_wallet: 'Acreditado en Billetera',
    no_transactions: 'Sin transacciones aún',
    no_transactions_sub: 'Tus depósitos y reembolsos aparecerán aquí una vez procesados.',
    pay_now: 'Pagar Ahora',
  },

  // Settings Screen
  settings: {
    title: 'Ajustes de la Cuenta',
    subtitle: 'Gestiona tus preferencias de perfil, moneda, credenciales de seguridad y acceso API.',
    tab_preferences: 'Preferencias y Moneda',
    tab_security: 'Seguridad y Contraseña',
    tab_api: 'Clave API y Revendedor',
    loc_title: 'Ubicación, Moneda e Idioma',
    loc_subtitle: 'Configura tu país, idioma preferido y moneda para tus pedidos y pagos.',
    field_country: 'País Principal',
    field_country_desc: 'Los pagos móviles y métodos locales usarán este país de forma predeterminada.',
    field_currency: 'Moneda de la Cuenta',
    field_language: 'Idioma Preferido',
    field_language_desc: 'Selecciona el idioma de visualización de la plataforma y notificaciones.',
    btn_save_preferences: 'Guardar Preferencias',
    btn_saving_preferences: 'Actualizando preferencias...',
    msg_preferences_saved: '¡Preferencias actualizadas con éxito!',
    security_title: 'Cambiar Contraseña',
    security_sub: 'Mantén protegida tu cuenta utilizando una contraseña segura.',
    current_password: 'Contraseña Actual',
    new_password: 'Nueva Contraseña',
    confirm_new_password: 'Confirmar Nueva Contraseña',
    btn_update_password: 'Actualizar Contraseña',
    api_title: 'Acceso API y Revendedor',
    api_sub: 'Integra los servicios de NiceBooster directamente en tu propia app o panel SMM.',
    api_key_label: 'Tu Clave Secreta API',
    generate_key: 'Generar Nueva Clave',
    copy_key: 'Copiar Clave',
    reseller_status: 'Acceso API Revendedor',
  },

  // Support Screen
  support: {
    title: 'Ayuda y Soporte',
    subtitle: 'Ponte en contacto con nuestro equipo de atención disponible 24/7.',
    whatsapp_chat: 'Chatear por WhatsApp',
    whatsapp_desc: 'Respuesta más rápida — promedio en menos de 5 minutos',
    telegram_chat: 'Soporte en Telegram',
    telegram_desc: 'Asistencia inmediata con nuestros agentes',
    email_support: 'Soporte por Correo',
    email_desc: 'Para consultas de facturación o acuerdos comerciales',
  },

  // Landing Page
  landing: {
    hero_title_1: 'Acelera tu crecimiento social a',
    hero_title_2: 'Precios de Mayorista',
    hero_subtitle: 'La plataforma automatizada todo en uno para creadores, agencias y empresas. Aumenta seguidores, likes, visitas y obtén números virtuales instantáneos para verificación SMS.',
    hero_cta_free: 'Empezar Gratis',
    hero_view_catalog: 'Ver Catálogo de Servicios',
    hero_trusted: 'Confiado por más de 50.000 creadores • MoMo y Cripto aceptados',
    stat_delivered_today: 'Entregados Hoy',
    stat_sms_received: 'SMS Recibidos',
    stat_orders_completed: 'Pedidos Completados',
    stat_active_creators: 'Creadores y Agencias Activas',
    stat_uptime: 'Disponibilidad del Sistema',
    stat_speed: 'Velocidad Media de Inicio',
    live_order_network: 'Red de Pedidos en Vivo',
    recent_activity: 'Actividad Reciente',
    final_cta_title: 'Impulsa tu Presencia Social Hoy',
    final_cta_subtitle: 'Únete a más de 50.000 creadores y marcas que crecen fácilmente con NiceBooster.',
    create_free_account: 'Crear Cuenta Gratis',
    talk_to_support: 'Hablar con Soporte',
    footer_nav: 'Navegación',
    footer_account: 'Cuenta',
    footer_support: 'Soporte y Legal',
  },

  // Flat keys for backwards compatibility
  nav_dashboard: 'Panel de control',
  nav_new_order: 'Nuevo pedido',
  nav_services: 'Servicios',
  nav_orders: 'Pedidos',
  nav_deposit: 'Recargar',
  nav_virtual_numbers: 'Números virtuales',
  nav_referrals: 'Programa de referidos',
  nav_settings: 'Ajustes',
  nav_support: 'Soporte',
  nav_guide: 'Guía',
  nav_logout: 'Cerrar sesión',
  nav_login: 'Iniciar sesión',
  nav_signup: 'Empezar gratis',
  nav_features: 'Características',
  nav_platforms: 'Plataformas',
  nav_how_it_works: 'Cómo funciona',
  nav_pricing: 'Precios',
  nav_faq: 'FAQ',
  nav_language: 'Idioma',
  settings_title: 'Ajustes de la cuenta',
  settings_subtitle: 'Gestiona tus preferencias de perfil, moneda regional, seguridad y acceso API.',
  tab_preferences: 'Preferencias y Moneda',
  tab_security: 'Seguridad y Contraseña',
  tab_api: 'Clave API y Revendedor',
  loc_title: 'Ubicación, Moneda e Idioma',
  loc_subtitle: 'Establece tu país, idioma preferido y moneda para tus pedidos y pagos.',
  field_country: 'País principal',
  field_country_desc: 'Los pagos móviles y métodos locales usarán este país por defecto.',
  field_currency: 'Moneda de la cuenta',
  field_language: 'Idioma preferido',
  field_language_desc: 'Selecciona el idioma de la plataforma y las notificaciones.',
  btn_save_preferences: 'Guardar preferencias',
  btn_saving_preferences: 'Actualizando preferencias...',
  msg_preferences_saved: '¡Preferencias actualizadas con éxito!',
  dash_smm_services: 'Servicios de Redes Sociales',
  dash_smm_desc: 'Aumenta tus seguidores, likes, visitas y engagement en todas las redes',
  dash_vn_title: 'Números Virtuales',
  dash_vn_desc: 'Recibe códigos SMS de verificación al instante con números privados',
  dash_popular_smm: 'Servicios de Redes Sociales Populares',
  dash_see_all_services: 'Ver todos los servicios',
  dash_popular_vn: 'Números Virtuales Populares',
  dash_browse_countries: 'Ver todos los países',
  dash_top_up: '+ Recargar',
  dash_total_orders: 'Pedidos Totales',
  dash_all_time_completed: 'Total completados',
  dash_total_spent: 'Total Gastado',
  dash_lifetime_volume: 'Volumen histórico',
  dash_vn_used: 'Números Virtuales Usados',
  dash_sms_verifications: 'Verificaciones SMS',
  dash_recent_orders: 'Pedidos Recientes',
  dash_recent_subtitle: 'Rastrea tus pedidos recientes y el estado de entrega',
  dash_refresh: 'Actualizar',
  dash_view_all_orders: 'Ver Todos los Pedidos →',
  col_order: 'Pedido',
  col_service: 'Service',
  col_quantity: 'Cantidad',
  col_cost: 'Coste',
  col_status: 'Estado',
  col_date: 'Fecha',
  no_orders_placed: 'Aún no has realizado pedidos',
  no_orders_desc: 'Elige un servicio de nuestro catálogo para impulsar tus perfiles hoy.',
  place_first_order: 'Hacer Primer Pedido',
  hero_title_1: 'Acelera tu crecimiento social a',
  hero_title_2: 'Precios de Mayorista',
  hero_subtitle: 'La plataforma automatizada todo en uno para creadores, agencias y empresas. Aumenta seguidores, likes, visitas y obtén números virtuales instantáneos para verificación SMS.',
  hero_cta_free: 'Empezar Gratis',
  hero_view_catalog: 'Ver Catálogo de Servicios',
  hero_trusted: 'Confiado por más de 50.000 creadores • MoMo y Cripto aceptados',
  stat_delivered_today: 'Entregados Hoy',
  stat_sms_received: 'SMS Recibidos',
  stat_orders_completed: 'Pedidos Completados',
  stat_active_creators: 'Creadores y Agencias Activas',
  stat_uptime: 'Disponibilidad del Sistema',
  stat_speed: 'Velocidad Media de Inicio',
  live_order_network: 'Red de Pedidos en Vivo',
  recent_activity: 'Actividad Reciente',
  final_cta_title: 'Impulsa tu Presencia Social Hoy',
  final_cta_subtitle: 'Únete a más de 50.000 creadores y marcas que crecen fácilmente con NiceBooster.',
  create_free_account: 'Crear Cuenta Gratis',
  talk_to_support: 'Hablar con Soporte',
  footer_nav: 'Navegación',
  footer_account: 'Cuenta',
  footer_support: 'Soporte y Legal',
  available_balance: 'Saldo disponible',
  add_funds: 'Añadir fondos',
  place_order: 'Crear pedido',
  category: 'Categoría',
  service: 'Servicio',
  quantity: 'Cantidad',
  link: 'Enlace',
  total_cost: 'Coste total',
  status: 'Estado',
  actions: 'Acciones',
  search: 'Buscar',
  cancel: 'Cancelar',
  loading: 'Cargando...',
  close: 'Cerrar',
};
